(function () {
  function getAvailabilityInputs(form) {
    return Array.from(form.querySelectorAll('input[type="checkbox"][name="filter.v.availability"]'));
  }

  function getInStockInput(form) {
    const inputs = getAvailabilityInputs(form);
    if (!inputs.length) return null;

    return (
      inputs.find((input) => input.value === '1') ||
      inputs.find((input) => /in\s*stock/i.test(input.closest('label')?.textContent || '')) ||
      inputs[0]
    );
  }

  function syncStockSwitch(form) {
    const toggle = form.querySelector('[data-nc-stock-switch]');
    if (!toggle) return;

    const inStock = getInStockInput(form);
    const isOn = Boolean(inStock && inStock.checked);
    toggle.classList.toggle('is-on', isOn);
    toggle.setAttribute('aria-checked', isOn ? 'true' : 'false');
  }

  function applyStockFilter(form, enable) {
    const inputs = getAvailabilityInputs(form);
    if (!inputs.length) return;

    const inStock = getInStockInput(form);
    let changed = false;

    inputs.forEach((input) => {
      const shouldCheck = enable && inStock && input === inStock;
      if (input.checked !== shouldCheck) {
        input.checked = shouldCheck;
        changed = true;
      }
    });

    if (changed) {
      form.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function onFormClick(event) {
    const switchBtn = event.target.closest('[data-nc-stock-switch]');
    if (!switchBtn) return;

    const form = switchBtn.closest('form');
    if (!form || (form.id !== 'FacetFiltersForm' && form.id !== 'FacetFiltersFormMobile')) return;

    event.preventDefault();
    const next = switchBtn.getAttribute('aria-checked') !== 'true';
    switchBtn.classList.toggle('is-on', next);
    switchBtn.setAttribute('aria-checked', next ? 'true' : 'false');
    applyStockFilter(form, next);
  }

  function observeForm(form) {
    if (!form || form.dataset.ncStockObserved === 'true') return;
    form.dataset.ncStockObserved = 'true';
    form.addEventListener('click', onFormClick);

    const observer = new MutationObserver(() => syncStockSwitch(form));
    observer.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked'] });
    syncStockSwitch(form);
  }

  function init() {
    observeForm(document.getElementById('FacetFiltersForm'));
    observeForm(document.getElementById('FacetFiltersFormMobile'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
